// import { useState } from "react";
import { Button, Paper } from "@mui/material";
import { useForm } from "react-hook-form";
import FormContainer from "./rh_form_elements/rh-form-container";
import TextFieldElement from "./rh_form_elements/rh-text-field-element";
import EmailFieldElement from "./rh_form_elements/rh-email-field-element";
import SwitchElement from "./rh_form_elements/rh-switch-element";
// import TextareaAutosizeElement from "./rh_form_elements/rh-text-area-autosize-element";
import JSONTextareaAutosizeElement from "./rh_form_elements/rh-json-text-area-autosize-element";

import { Stack } from "@mui/material";




export default function OcrolusSecretForm(props) {
  
  
  const defaultValues = props.data?props.data:{};
  const values = defaultValues
 
  //const [values, setValues] = useState(defaultValues)
  
  
  const formContext = useForm({
    defaultValues: defaultValues, values
  });

  const { handleSubmit } = formContext;

  const onSubmitWithDefaults = (data) => {
    data.accountName = data.accountName? data.accountName : defaultValues.secretName !== null ? defaultValues.accountName: null;
    data.defaultSecret = data.defaultSecret? data.defaultSecret: defaultValues.defaultSecret !== undefined ? defaultValues.defaultSecret : undefined;

    console.log('OcrolusSecretForm Submit:', data)
    props.onSubmit(data)
  }

  console.log('OcrolusSecretForm:', values)

  return (
    


      <Paper
        style={{
          display: "grid",
          gridRowGap: "20px",
          padding: "20px",
          //margin: "10px 300px",
          maxWidth: "500px",
        }}
      >
        <FormContainer formContext={formContext} handleSubmit={handleSubmit} >
          <Stack spacing={2}>
            <EmailFieldElement name="accountName" label="Account Email" required disabled={values.secretName!==undefined} />
            
            <TextFieldElement name="accountDescription" label="Account Description" required />
            <SwitchElement name="defaultSecret" label="Default Secret" required disabled={values.defaultSecret}/>
            <JSONTextareaAutosizeElement name="secretData" label="Secret Data" required/>
          </Stack>

          
          <Button
            style={{
              //padding: "20px",
              margin: "10px 0px",
              maxWidth: "75px",
            }}
            onClick={handleSubmit(onSubmitWithDefaults)} variant={"contained"}>
            Save
          </Button>
          <Button style={{
            //padding: "20px",
            margin: "10px 10px",
            maxWidth: "75px",
          }}
            onClick={props.onCancel} variant={"outlined"}>
            Cancel
          </Button>


        </FormContainer>
        
      </Paper>
      

    

  );
};